import React from "react";
import { Route, Redirect } from "react-router-dom";
import { pathArray } from "../utils/utils";
import { useSelector } from "react-redux";

const ExamSectionPrivateRoute = ({ component: Component, ...rest }) => {
  let candidateAuthArray = useSelector((state) => state.candidateAuth);
  let details = useSelector((state) => state.examDetail.details);
  return (
    <Route
      {...rest}
      render={(props) => {
        let params = props.match.params;
        console.log({ params });
        return candidateAuthArray.length === 6 &&
          params?.examId === details._id ? (
          <Component {...props} />
        ) : (
          <Redirect to={"/exam"} from={pathArray[pathArray.length - 1]} />
        );
      }}
    />
  );
};

export default ExamSectionPrivateRoute;
